import type { FormikProps } from 'formik';
import type { TFunction } from 'i18next';
import { ValidationError } from 'yup';

import type { ClientFormValues } from '../models/Forms';
import { requiredPostalCodeField } from '../validation';

export const clientAddressFieldsBeforeGoogleValidation = ['street', 'streetNumber', 'city', 'state'] as const;

export async function showClientAddressFormValidationErrors(formik: FormikProps<ClientFormValues>): Promise<boolean> {
  const errors = await formik.validateForm();
  let hasAddressError = false;

  for (const field of clientAddressFieldsBeforeGoogleValidation) {
    const errorMessage = errors[field];
    if (typeof errorMessage !== 'string') {
      continue;
    }
    formik.setFieldError(field, errorMessage);
    void formik.setFieldTouched(field, true, false);
    hasAddressError = true;
  }

  return hasAddressError;
}

export function applyClientPostalCodeValidationErrors(
  formik: FormikProps<ClientFormValues>,
  values: ClientFormValues,
  t: TFunction,
): boolean {
  try {
    requiredPostalCodeField(t).validateSync(values.psc);
    return false;
  } catch (error) {
    if (!(error instanceof ValidationError)) {
      throw error;
    }
    formik.setFieldError('psc', error.message);
    void formik.setFieldTouched('psc', true, false);
    return true;
  }
}

export function shouldBlockContinueWithoutPostalCode(values: ClientFormValues): boolean {
  if (values.psc?.trim()) {
    return false;
  }
  return values.addressValidationStatus !== 'user_override';
}
